export const showContactForm = (nr) =>{
    return{
      type : 'SHOWCONTACTFORM',
      payload : nr
    }
  }